import React, { useMemo, useState } from 'react';
import { Field, Text, Area, File, Select, RepeatList, useEmit } from './fields';

const blank = () => ({
    WorkerContractor: '', WorkerNationality: '', WorkerFirstName: '', WorkerLastName: '',
    WorkerEmail: '', WorkerContactNo: '', WorkerComments: '',
    PassportNumber: '', PassportIssue: '', PassportExpiry: '', PassportAttachment: '',
    VisaNumber: '', VisaIssue: '', VisaExpiry: '', VisaAttachment: '',
    EmiratesIDNumber: '', EmiratesIDExpiry: '', EmiratesIDAttachment: '',
});

/** Emits an array of worker objects (attachments = filenames). `contractors` fills the dropdown. */
const WorkerDetails = ({ onDataChange, contractors = [] }) => {
    const [rows, setRows] = useState([blank()]);
    const data = useMemo(() => rows, [rows]);
    useEmit(data, onDataChange);

    const contractorOptions = (contractors || []).map((c) => c.ContractorName).filter(Boolean);
    const set = (i, key, val) => setRows((prev) => prev.map((r, idx) => idx === i ? { ...r, [key]: val } : r));
    const add = () => setRows((prev) => [...prev, blank()]);
    const remove = (i) => setRows((prev) => prev.filter((_, idx) => idx !== i));
    const clear = (i) => setRows((prev) => prev.map((r, idx) => idx === i ? blank() : r));

    return (
        <div className="v3-wp-card">
            <div className="v3-wp-card-head"><h6 className="v3-wp-card-title">Worker Details</h6></div>
            <RepeatList
                title="Worker" items={rows} onAdd={add} onRemove={remove} onClear={clear} addLabel="Add Worker"
                renderRow={(w, i) => (
                    <>
                        <div className="v3-wp-grid">
                            <Field label="Contractor" required><Select value={w.WorkerContractor} onChange={(v) => set(i, 'WorkerContractor', v)} options={contractorOptions} placeholder="Select Contractor" /></Field>
                            <Field label="Nationality"><Text value={w.WorkerNationality} onChange={(v) => set(i, 'WorkerNationality', v)} placeholder="Nationality" /></Field>
                            <Field label="First Name" required><Text value={w.WorkerFirstName} onChange={(v) => set(i, 'WorkerFirstName', v)} /></Field>
                            <Field label="Last Name" required><Text value={w.WorkerLastName} onChange={(v) => set(i, 'WorkerLastName', v)} /></Field>
                            <Field label="Email"><Text type="email" value={w.WorkerEmail} onChange={(v) => set(i, 'WorkerEmail', v)} /></Field>
                            <Field label="Contact Number"><Text value={w.WorkerContactNo} onChange={(v) => set(i, 'WorkerContactNo', v)} /></Field>
                        </div>
                        <div className="v3-wp-label" style={{ margin: '12px 0 6px' }}>Passport</div>
                        <div className="v3-wp-grid cols-4">
                            <Field label="Passport No"><Text value={w.PassportNumber} onChange={(v) => set(i, 'PassportNumber', v)} /></Field>
                            <Field label="Issue Date"><Text type="date" value={w.PassportIssue} onChange={(v) => set(i, 'PassportIssue', v)} /></Field>
                            <Field label="Expiry Date"><Text type="date" value={w.PassportExpiry} onChange={(v) => set(i, 'PassportExpiry', v)} /></Field>
                            <Field label="Attachment"><File onChange={(f) => set(i, 'PassportAttachment', f ? f.name : '')} /></Field>
                        </div>
                        <div className="v3-wp-label" style={{ margin: '12px 0 6px' }}>Visa</div>
                        <div className="v3-wp-grid cols-4">
                            <Field label="Visa No"><Text value={w.VisaNumber} onChange={(v) => set(i, 'VisaNumber', v)} /></Field>
                            <Field label="Issue Date"><Text type="date" value={w.VisaIssue} onChange={(v) => set(i, 'VisaIssue', v)} /></Field>
                            <Field label="Expiry Date"><Text type="date" value={w.VisaExpiry} onChange={(v) => set(i, 'VisaExpiry', v)} /></Field>
                            <Field label="Attachment"><File onChange={(f) => set(i, 'VisaAttachment', f ? f.name : '')} /></Field>
                        </div>
                        <div className="v3-wp-label" style={{ margin: '12px 0 6px' }}>Emirates ID</div>
                        <div className="v3-wp-grid cols-3">
                            <Field label="Emirates ID"><Text value={w.EmiratesIDNumber} onChange={(v) => set(i, 'EmiratesIDNumber', v)} /></Field>
                            <Field label="Expiry Date"><Text type="date" value={w.EmiratesIDExpiry} onChange={(v) => set(i, 'EmiratesIDExpiry', v)} /></Field>
                            <Field label="Attachment"><File onChange={(f) => set(i, 'EmiratesIDAttachment', f ? f.name : '')} /></Field>
                        </div>
                        <div className="v3-wp-grid" style={{ marginTop: 12 }}>
                            <Field label="Comments" full><Area value={w.WorkerComments} onChange={(v) => set(i, 'WorkerComments', v)} rows={2} /></Field>
                        </div>
                    </>
                )}
            />
        </div>
    );
};

export default WorkerDetails;
